// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stripe-checkout-coupon {
  background: #f7f7f5;
  border: 1px solid #ececec;
  border-radius: 12px;
  padding: 12px;
}

.stripe-checkout-coupon__row {
  display: flex;
  gap: 8px;
}

.stripe-checkout-coupon__row .form-control {
  height: 42px;
  border-radius: 10px;
  font-size: 14px;
}

.stripe-checkout-coupon__apply {
  height: 42px;
  white-space: nowrap;
  border-radius: 10px;
  font-weight: 600;
  background: #0e0e0e;
  border: none;
  color: #fff;
  padding: 0 16px;
}

.stripe-checkout-coupon__apply:disabled {
  opacity: 0.55;
}

.stripe-checkout-coupon__applied {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #eef7ee;
  color: #1f7a32;
  font-size: 13px;
  font-weight: 600;
}

.stripe-checkout-coupon__remove {
  border: 0;
  background: transparent;
  color: #1f7a32;
  font-size: 12px;
  font-weight: 700;
  text-decoration: underline;
  padding: 0;
}

.stripe-checkout-summary {
  border: 1px solid #ececec;
  border-radius: 12px;
  padding: 12px 14px;
  background: #fff;
}

.stripe-checkout-summary__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  color: #444;
}

.stripe-checkout-summary__row + .stripe-checkout-summary__row {
  margin-top: 8px;
}

.stripe-checkout-summary__row--total {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ececec;
  color: #111;
  font-weight: 700;
}

.stripe-checkout-summary__save {
  color: #1f7a32;
}

.stripe-checkout-pay {
  background: #c93312 !important;
  color: #fff !important;
  border: none !important;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/modals/StripeCheckoutModal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".stripe-checkout-coupon {\n  background: #f7f7f5;\n  border: 1px solid #ececec;\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.stripe-checkout-coupon__row {\n  display: flex;\n  gap: 8px;\n}\n\n.stripe-checkout-coupon__row .form-control {\n  height: 42px;\n  border-radius: 10px;\n  font-size: 14px;\n}\n\n.stripe-checkout-coupon__apply {\n  height: 42px;\n  white-space: nowrap;\n  border-radius: 10px;\n  font-weight: 600;\n  background: #0e0e0e;\n  border: none;\n  color: #fff;\n  padding: 0 16px;\n}\n\n.stripe-checkout-coupon__apply:disabled {\n  opacity: 0.55;\n}\n\n.stripe-checkout-coupon__applied {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 10px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: #eef7ee;\n  color: #1f7a32;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.stripe-checkout-coupon__remove {\n  border: 0;\n  background: transparent;\n  color: #1f7a32;\n  font-size: 12px;\n  font-weight: 700;\n  text-decoration: underline;\n  padding: 0;\n}\n\n.stripe-checkout-summary {\n  border: 1px solid #ececec;\n  border-radius: 12px;\n  padding: 12px 14px;\n  background: #fff;\n}\n\n.stripe-checkout-summary__row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 14px;\n  color: #444;\n}\n\n.stripe-checkout-summary__row + .stripe-checkout-summary__row {\n  margin-top: 8px;\n}\n\n.stripe-checkout-summary__row--total {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #ececec;\n  color: #111;\n  font-weight: 700;\n}\n\n.stripe-checkout-summary__save {\n  color: #1f7a32;\n}\n\n.stripe-checkout-pay {\n  background: #c93312 !important;\n  color: #fff !important;\n  border: none !important;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
